import { AloftDate } from '@aloft/toolkit-shared';

import { createTextFieldNode } from './createTextFieldNode.js';

/**
 * Generate all the nodes that are mapped to order input to RPTI report
 * @param doc - Document object to create html nodes
 * @param effectiveDate - Effective Date AloftDate from the TKv2Order
 * @returns - list of OrderInput xml Nodes
 */
export function generateOrderInputRptiNodes(
  doc: Document,
  effectiveDate: AloftDate | undefined,
): HTMLElement[] {
  const rptiNodes = [];
  rptiNodes.push(
    createTextFieldNode(doc, {
      Id: 'AppraisedValueDate',
      Data: effectiveDate?.format('MM/dd/yyyy'),
    }),
  );

  return rptiNodes;
}
